import { render, staticRenderFns } from "./accestype.vue?vue&type=template&id=172fc72f&"
import script from "./accestype.vue?vue&type=script&lang=js&"
export * from "./accestype.vue?vue&type=script&lang=js&"
import style0 from "./accestype.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports